import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import TransparentButton from '@/trio-ui/TransparentButton';
import UserInitials, { UserInitialsProps } from '@/trio-ui/UserInitials';
import * as Styles from './AssignableUser.styles';

export type AssignableUserProps = UserInitialsProps & {
  onRemove?: (id: string) => void;
  onAssign?: (id: string) => void;
  disableRemoveButton?: boolean;
  id: string;
};

export default function AssignableUser({
  onRemove,
  onAssign,
  firstName,
  lastName,
  pictureUrl,
  id,
  disableRemoveButton = false,
  ...props
}: AssignableUserProps): JSX.Element {
  return (
    <Styles.Suggestion data-testid="assignable-user" {...props}>
      <div className="flex align-center">
        <UserInitials
          className="tw-shrink-0"
          size={24}
          pictureUrl={pictureUrl}
          firstName={firstName}
          lastName={lastName}
        />
        <Styles.SuggestionName data-testid="assignable-user-name">
          {firstName} {lastName}
        </Styles.SuggestionName>
      </div>
      <div>
        {onAssign && (
          <TransparentButton
            data-testid="assignable-user-assign-button"
            onClick={() => onAssign(id)}
            isBlueButton
          >
            <>
              <AssignmentTurnedInOutlinedIcon />
              Assign
            </>
          </TransparentButton>
        )}

        {onRemove && (
          <TransparentButton
            data-testid="assignable-user-remove-button"
            onClick={() => onRemove(id)}
            isRedButton
            type="button"
            disabled={disableRemoveButton}
          >
            <>
              <DeleteIcon />
              Remove
            </>
          </TransparentButton>
        )}
      </div>
    </Styles.Suggestion>
  );
}
